import { KeycloakService } from 'keycloak-angular';
import { keycloakConfig } from './keycloak.config';

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init(keycloakConfig)
      .then(authenticated => {
        console.log('Authenticated:', authenticated);
      })
      .catch(err => {
        console.error('Keycloak init error:', err);
      });
}
